export default __webpack_public_path__ + "static/media/elements.80213337.png";